import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Keyboard"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 19.5C2.17157 19.5 1.5 18.8284 1.5 18V7.5C1.5 6.67157 2.17157 6 3 6H21C21.8284 6 22.5 6.67157 22.5 7.5V18C22.5 18.8284 21.8284 19.5 21 19.5H3ZM4.5 9H6V10.5H4.5V9ZM7.5 15H15.75V16.5H7.5V15ZM9 9H7.5V10.5H9V9ZM10.5 9H12V10.5H10.5V9ZM15 9H13.5V10.5H15V9ZM4.5 15H6V16.5H4.5V15ZM6 12H4.5V13.5H6V12ZM7.5 12H9V13.5H7.5V12ZM12 12H10.5V13.5H12V12ZM16.5 9H19.5V10.5H16.5V9ZM19.5 12H16.5V13.5H19.5V12ZM13.5 12H15V13.5H13.5V12ZM19.5 15H17.25V16.5H19.5V15ZM3 18V7.5H21V18H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Keyboard.vue"]]);
